export default __webpack_public_path__ + "static/media/angle-right-gray.1595849e.svg";